import { Thunk } from 'ha/myredux/types';
import { defineKey as T } from '@ha/intl';
import { AlertType, AlertDismissAfter } from 'ha/modules/Alertbar/types';
import { send } from 'ha/modules/Alertbar/actions';
import { ErrorMessages } from 'ha/constants/ErrorMessages';

const reportUser =
  (
    reportedUserID: number,
    { reason, onSuccess }: { reason: string; onSuccess?: () => void },
  ): Thunk =>
  (dispatch, __, { apiV2 }) =>
    apiV2
      .reportUser(reportedUserID, { reason })
      .then(() => {
        onSuccess?.();
      })
      .catch(() => {
        dispatch(
          send({
            text: T(ErrorMessages.something_went_wrong),
            kind: AlertType.Danger,
            dismissAfter: AlertDismissAfter.Default,
          }),
        );
      });

export { reportUser };
